// extracted by mini-css-extract-plugin
export default {"root":"styles_root__P1N6x","text":"styles_text__0+teA"};